module.exports = __webpack_public_path__ + "img/img-normal.1e2dcb7e.svg";